<template>
<div>
   <RecordNotFound v-if="status_code==404" :message="status_message" :duplicatecode="duplicatecode"></RecordNotFound>
  <div v-else class="invoice-create-page">
    <!--  credit form component -->

    <AmcServiceForm page="create" :lists="lists" v-on:onSubmit="onSubmit($event)">
      <!-- footer block -->
    </AmcServiceForm>
  </div>
  </div>
</template>
 
<script scoped>
import moment from "moment"; // to control date format
import AmcServiceForm from "@/components/Form/Amc/RecordService"; // payment form for update payment record
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
export default {
  mixins: [notificationMixin, formatDate],
  name: "Records", // page name
  components: {
    AmcServiceForm,
    RecordNotFound
  },
  data() {
    return {
      lists: "",
      submitted: false,
       duplicatecode:false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    //validation during onsubmit
    onSubmit(data) {
      this.$validator.validateAll().then(result => {
        if (result) {
          // this.submitted = true;
          //   //  send the json data

          this.$store
            .dispatch("amccontract/updateService", data)
            .then(() => {
              var message, type;
              if (this.status_code == 200) {
                //  show if amc service has been recorded and  successfully created
                type = "success"
                message = this.status_message;
                this.$router.push({
                  name: "AmcContractView",
                  params: {
                    id: this.list.amc_header_detail.amc_hdr_id
                  }
                });
              } else {
                //         //  showing eror message
                type = this.status_type;
                message = this.status_message;
                  this.duplicatecode = true;
                  this.submitted = false;

              }
              //       //  code for notificatin display
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: message,
                type: type,
                showCloseButton: true
              });
            })
            .catch(() => {});
        } else {
          this.error_show = true; // show validatioj message
        }
      });
      return false;
    },
    //  to get the json value
    getPresentValue(arr, prop, val, return_prop) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = i;
          break;
        }
      }
      return hasMatch;
    }
  },
  created() {
    this.initializationMessengerCode();
    var index = this.getPresentValue(
      this.list.amc_item_detail,
      "amc_itm_id",
      this.$route.params.id,
      ""
    );

    this.lists = {
      amc_end_date: moment(this.list.amc_header_detail.amc_end_date)
        .add(1, "days")
        .format("YYYY-MM-DD"),
      amc_start_date: moment(this.list.amc_header_detail.amc_start_date)
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      service_date: this.formatDate(new Date()),
      service_name: this.list.amc_item_detail[index].pdt_name,
      cus_id: this.list.amc_header_detail.cus_name,
      pdt_qty:
        parseInt(this.list.amc_item_detail[index].pdt_qty) -
        parseInt(this.list.amc_item_detail[index].pdt_used_qty),
      amc_pdt_qty: 1,
      amc_itm_id: this.$route.params.id,
      total_pdt_qty: this.list.amc_header_detail.total_pdt_qty,
      total_used_qty: this.list.amc_header_detail.total_used_qty
    };
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      list: state => state.amccontract.Viewlist,
      code: state => state.amccontract.code,
      status_code: state => state.amccontract.status_code, 
      status_message: state => state.amccontract.status_message, 
      status_type: state => state.amccontract.status_type
    })
  }
};
</script>